import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon, { WhatsAppIcon } from './Icon';
import Magnetic from '../motion/Magnetic';
import SplitText from '../motion/SplitText';
import { Reveal } from '../motion/Reveal';
import { scrollToTop } from '../motion/SmoothScroll';
import { CONTACT, NAV_LINKS } from '../data/site';

const SERVICES = ['Project Management (PMC)', 'Turnkey Construction', 'Residential & Commercial Builds', 'Layout & Infrastructure', 'Cost Control', 'Quality Assurance'];

export function CircleButton({ to = '/request-consultation', label = "Start a project • Let's talk • " }) {
  return (
    <Magnetic strength={0.4}>
      <Link to={to} className="circle-btn" aria-label="Start a project">
        <svg className="ring-text" viewBox="0 0 100 100" aria-hidden="true">
          <defs><path id="circlePath" d="M50,50 m-40,0 a40,40 0 1,1 80,0 a40,40 0 1,1 -80,0" /></defs>
          <text><textPath href="#circlePath" textLength="248" lengthAdjust="spacing">{label}</textPath></text>
        </svg>
        <span className="center"><Icon name="arrow" size={22} /></span>
      </Link>
    </Magnetic>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="aurora" /><div className="noise" />
      <div className="container">
        <div className="footer-cta">
          <SplitText as="h2" inView text="Let's build|something *lasting.*" />
          <Reveal from="zoom" delay={0.3}><CircleButton /></Reveal>
        </div>

        <div className="footer-grid">
          <Reveal className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="mark"><img src="/logo-160.png" alt="" /></span>
              <strong>Blue Block PMC</strong>
            </Link>
            <p>From foundation to finish — end-to-end project management excellence for every scale of civil construction.</p>
            <div className="socials">
              <a className="social" href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><WhatsAppIcon size={18} /></a>
              <a className="social" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" /></svg>
              </a>
              <a className="social" href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M14 8h3V4h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V9a1 1 0 0 1 1-1Z" /></svg>
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h4>Company</h4>
            <ul className="footer-links">
              {NAV_LINKS.map((l) => <li key={l.path}><Link to={l.path}>{l.label}</Link></li>)}
              <li><Link to="/request-consultation">Contact Us</Link></li>
            </ul>
          </Reveal>
          <Reveal delay={0.16}>
            <h4>Services</h4>
            <ul className="footer-links">{SERVICES.map((s) => <li key={s}><Link to="/services">{s}</Link></li>)}</ul>
          </Reveal>
          <Reveal delay={0.24}>
            <h4>Get in touch</h4>
            <div className="footer-contact">
              <div><Icon name="pin" size={18} /><span>{CONTACT.address}, {CONTACT.city} – {CONTACT.pincode}</span></div>
              <a href={CONTACT.phoneHref}><Icon name="phone" size={18} />{CONTACT.phone}</a>
              <a href={`mailto:${CONTACT.email}`}><Icon name="mail" size={18} />{CONTACT.email}</a>
              <div><Icon name="clock" size={18} />{CONTACT.hours}</div>
            </div>
          </Reveal>
        </div>
      </div>

      <motion.div className="footer-giant" aria-hidden="true" initial={{ y: '40%', opacity: 0 }} whileInView={{ y: '0%', opacity: 1 }}
        viewport={{ once: true }} transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}>BLUE BLOCK</motion.div>

      <div className="container">
        <div className="footer-bottom">
          <span>© {year} Blue Block PMC. All rights reserved.</span>
          <button onClick={() => scrollToTop(false)} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', display: 'inline-flex', gap: 8, alignItems: 'center', font: 'inherit' }}>
            Back to top <Icon name="chevronDown" size={16} style={{ transform: 'rotate(180deg)' }} />
          </button>
        </div>
      </div>
    </footer>
  );
}
